import { useDispatch } from "src/store";

import { showDetails } from "@dashboard/devices/store";
import { DateCell } from "@shared/table/DateCell";

type Props = {
    id: number;
    value: string;
};

export const RolloutTableDateCell = (props: Props) => {
    const { id, value } = props;
    const dispatch = useDispatch();

    const onRollout = () => {
        dispatch(showDetails({ type: "rollout", selectedId: id }));
    };

    return <DateCell value={value} onClick={onRollout} />;
};
